export default __webpack_public_path__ + "static/media/mus-boysoffaith.08902ef0.mp4";